const parseSettings = (settings?: unknown): Array<Record<string, any>> => {
  if (Array.isArray(settings)) return settings as Array<Record<string, any>>;
  if (typeof settings === "string") {
    try {
      const parsed = JSON.parse(settings);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  if (typeof window === "undefined") return [];

  try {
    const parsed = JSON.parse(window.sessionStorage?.getItem("settings") || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const isNarrativeOcgFeatureEnabled = (settings?: unknown): boolean => {
  const featureOcg = parseSettings(settings).find((setting) => setting?.name === "FEATURE_OCG");
  return Boolean(featureOcg?.value?.ENABLED);
};
